export interface CountryCode {
  code: string;
  country: string;
  digits: number;
  placeholder: string;
}

export const COUNTRY_CODES: CountryCode[] = [
  { code: '+93', country: 'Afghanistan', digits: 9, placeholder: '7XX XXX XXX' },
  { code: '+355', country: 'Albania', digits: 9, placeholder: '6X XXX XXXX' },
  { code: '+213', country: 'Algeria', digits: 9, placeholder: '5XX XXX XXX' },
  { code: '+1684', country: 'American Samoa', digits: 10, placeholder: '555 XXX XXXX' },
  { code: '+376', country: 'Andorra', digits: 6, placeholder: '3XX XXX' },
  { code: '+244', country: 'Angola', digits: 9, placeholder: '9XX XXX XXX' },
  { code: '+1264', country: 'Anguilla', digits: 10, placeholder: '555 XXX XXXX' },
  { code: '+1268', country: 'Antigua and Barbuda', digits: 10, placeholder: '555 XXX XXXX' },
  { code: '+54', country: 'Argentina', digits: 10, placeholder: '11 XXXX XXXX' },
  { code: '+374', country: 'Armenia', digits: 8, placeholder: 'XX XXX XXX' },
  { code: '+297', country: 'Aruba', digits: 7, placeholder: 'XXX XXXX' },
  { code: '+61', country: 'Australia', digits: 9, placeholder: '4XX XXX XXX' },
  { code: '+43', country: 'Austria', digits: 10, placeholder: '6XX XXXXXXX' },
  { code: '+994', country: 'Azerbaijan', digits: 9, placeholder: '5XX XXX XXX' },
  { code: '+1242', country: 'Bahamas', digits: 10, placeholder: '555 XXX XXXX' },
  { code: '+973', country: 'Bahrain', digits: 8, placeholder: '3XXX XXXX' },
  { code: '+880', country: 'Bangladesh', digits: 10, placeholder: '1XXX XXXXXX' },
  { code: '+1246', country: 'Barbados', digits: 10, placeholder: '555 XXX XXXX' },
  { code: '+375', country: 'Belarus', digits: 9, placeholder: '2X XXX XXXX' },
  { code: '+32', country: 'Belgium', digits: 9, placeholder: '4XX XX XX XX' },
  { code: '+501', country: 'Belize', digits: 7, placeholder: '6XX XXXX' },
  { code: '+229', country: 'Benin', digits: 8, placeholder: '9X XX XX XX' },
  { code: '+1441', country: 'Bermuda', digits: 10, placeholder: '555 XXX XXXX' },
  { code: '+975', country: 'Bhutan', digits: 8, placeholder: '17 XX XX XX' },
  { code: '+591', country: 'Bolivia', digits: 8, placeholder: '7XX XXXX' },
  { code: '+387', country: 'Bosnia and Herzegovina', digits: 8, placeholder: '6X XXXXXX' },
  { code: '+267', country: 'Botswana', digits: 8, placeholder: '7X XXX XXX' },
  { code: '+55', country: 'Brazil', digits: 11, placeholder: '11 9XXXX XXXX' },
  { code: '+246', country: 'British Indian Ocean Territory', digits: 7, placeholder: 'XXX XXXX' },
  { code: '+1284', country: 'British Virgin Islands', digits: 10, placeholder: '555 XXX XXXX' },
  { code: '+673', country: 'Brunei', digits: 7, placeholder: '7XX XXXX' },
  { code: '+359', country: 'Bulgaria', digits: 9, placeholder: '8X XXX XXXX' },
  { code: '+226', country: 'Burkina Faso', digits: 8, placeholder: '7X XX XX XX' },
  { code: '+257', country: 'Burundi', digits: 8, placeholder: '7X XX XX XX' },
  { code: '+855', country: 'Cambodia', digits: 9, placeholder: '9X XXX XXX' },
  { code: '+237', country: 'Cameroon', digits: 9, placeholder: '6XX XXX XXX' },
  { code: '+1', country: 'Canada', digits: 10, placeholder: '555 XXX XXXX' },
  { code: '+238', country: 'Cape Verde', digits: 7, placeholder: '9X XXXXX' },
  { code: '+1345', country: 'Cayman Islands', digits: 10, placeholder: '555 XXX XXXX' },
  { code: '+236', country: 'Central African Republic', digits: 8, placeholder: '7X XX XX XX' },
  { code: '+235', country: 'Chad', digits: 8, placeholder: '9X XX XX XX' },
  { code: '+56', country: 'Chile', digits: 9, placeholder: '9X XXX XXX' },
  { code: '+86', country: 'China', digits: 11, placeholder: '1XX XXXX XXXX' },
  { code: '+57', country: 'Colombia', digits: 10, placeholder: '3XX XXX XXXX' },
  { code: '+269', country: 'Comoros', digits: 7, placeholder: '3X XX XX XX' },
  { code: '+242', country: 'Congo (Brazzaville)', digits: 9, placeholder: '0X XXX XXXX' },
  { code: '+243', country: 'Congo (Kinshasa)', digits: 9, placeholder: '8X XXX XXXX' },
  { code: '+682', country: 'Cook Islands', digits: 5, placeholder: 'XX XXX' },
  { code: '+506', country: 'Costa Rica', digits: 8, placeholder: 'XXXX XXXX' },
  { code: '+225', country: "Cote d'Ivoire", digits: 10, placeholder: '0X XX XX XX XX' },
  { code: '+385', country: 'Croatia', digits: 9, placeholder: '9X XXX XXX' },
  { code: '+53', country: 'Cuba', digits: 8, placeholder: '5XXXXXXX' },
  { code: '+357', country: 'Cyprus', digits: 8, placeholder: '9X XXXXXX' },
  { code: '+420', country: 'Czech Republic', digits: 9, placeholder: '6XX XXX XXX' },
  { code: '+45', country: 'Denmark', digits: 8, placeholder: 'XX XX XX XX' },
  { code: '+253', country: 'Djibouti', digits: 8, placeholder: '7X XX XX XX' },
  { code: '+1767', country: 'Dominica', digits: 10, placeholder: '555 XXX XXXX' },
  { code: '+1809', country: 'Dominican Republic', digits: 10, placeholder: '555 XXX XXXX' },
  { code: '+593', country: 'Ecuador', digits: 9, placeholder: '9X XXX XXXX' },
  { code: '+20', country: 'Egypt', digits: 10, placeholder: '1XX XXX XXXX' },
  { code: '+503', country: 'El Salvador', digits: 8, placeholder: '7XX XXXX' },
  { code: '+240', country: 'Equatorial Guinea', digits: 9, placeholder: '2XX XXX XXX' },
  { code: '+291', country: 'Eritrea', digits: 7, placeholder: 'X XXX XXX' },
  { code: '+372', country: 'Estonia', digits: 8, placeholder: '5X XXXXXX' },
  { code: '+268', country: 'Eswatini', digits: 8, placeholder: '76X XXXX' },
  { code: '+251', country: 'Ethiopia', digits: 9, placeholder: '9XX XXX XXX' },
  { code: '+679', country: 'Fiji', digits: 7, placeholder: '7XX XXXX' },
  { code: '+358', country: 'Finland', digits: 9, placeholder: '4X XXX XXXX' },
  { code: '+33', country: 'France', digits: 9, placeholder: '6 XX XX XX XX' },
  { code: '+594', country: 'French Guiana', digits: 9, placeholder: '6XX XXX XXX' },
  { code: '+689', country: 'French Polynesia', digits: 8, placeholder: '8X XX XX XX' },
  { code: '+241', country: 'Gabon', digits: 8, placeholder: '0X XX XX XX' },
  { code: '+220', country: 'Gambia', digits: 7, placeholder: '3X XXXXX' },
  { code: '+995', country: 'Georgia', digits: 9, placeholder: '5XX XXX XXX' },
  { code: '+49', country: 'Germany', digits: 10, placeholder: '1XX XXXXXXX' },
  { code: '+233', country: 'Ghana', digits: 9, placeholder: '2X XXX XXXX' },
  { code: '+350', country: 'Gibraltar', digits: 8, placeholder: '5XXXXXXX' },
  { code: '+30', country: 'Greece', digits: 10, placeholder: '6XX XXX XXXX' },
  { code: '+1473', country: 'Grenada', digits: 10, placeholder: '555 XXX XXXX' },
  { code: '+590', country: 'Guadeloupe', digits: 9, placeholder: '6XX XXX XXX' },
  { code: '+1671', country: 'Guam', digits: 10, placeholder: '555 XXX XXXX' },
  { code: '+502', country: 'Guatemala', digits: 8, placeholder: '5XX XXXX' },
  { code: '+224', country: 'Guinea', digits: 9, placeholder: '6XX XXX XXX' },
  { code: '+245', country: 'Guinea-Bissau', digits: 7, placeholder: '5X XXXXX' },
  { code: '+592', country: 'Guyana', digits: 7, placeholder: '5XX XXXX' },
  { code: '+509', country: 'Haiti', digits: 8, placeholder: '3X XXX XXXX' },
  { code: '+504', country: 'Honduras', digits: 8, placeholder: '9XX XXXX' },
  { code: '+852', country: 'Hong Kong', digits: 8, placeholder: '5XXX XXXX' },
  { code: '+36', country: 'Hungary', digits: 9, placeholder: '20 XXX XXXX' },
  { code: '+354', country: 'Iceland', digits: 7, placeholder: '6X XXXXX' },
  { code: '+91', country: 'India', digits: 10, placeholder: '9XX XXX XXXX' },
  { code: '+62', country: 'Indonesia', digits: 10, placeholder: '8XX XXX XXXX' },
  { code: '+98', country: 'Iran', digits: 10, placeholder: '9XX XXX XXXX' },
  { code: '+964', country: 'Iraq', digits: 10, placeholder: '7XX XXX XXXX' },
  { code: '+353', country: 'Ireland', digits: 9, placeholder: '8X XXX XXXX' },
  { code: '+972', country: 'Israel', digits: 9, placeholder: '5X XXX XXXX' },
  { code: '+39', country: 'Italy', digits: 10, placeholder: '3XX XXX XXXX' },
  { code: '+1876', country: 'Jamaica', digits: 10, placeholder: '555 XXX XXXX' },
  { code: '+81', country: 'Japan', digits: 10, placeholder: '90 XXXX XXXX' },
  { code: '+962', country: 'Jordan', digits: 9, placeholder: '7X XXX XXXX' },
  { code: '+7', country: 'Kazakhstan', digits: 10, placeholder: '7XX XXX XXXX' },
  { code: '+254', country: 'Kenya', digits: 9, placeholder: '7XX XXX XXX' },
  { code: '+686', country: 'Kiribati', digits: 5, placeholder: 'XXXXX' },
  { code: '+383', country: 'Kosovo', digits: 8, placeholder: '4X XXX XXX' },
  { code: '+965', country: 'Kuwait', digits: 8, placeholder: '5XXXXXXX' },
  { code: '+996', country: 'Kyrgyzstan', digits: 9, placeholder: '7XX XXX XXX' },
  { code: '+856', country: 'Laos', digits: 9, placeholder: '20 XXX XXXX' },
  { code: '+371', country: 'Latvia', digits: 8, placeholder: '2X XXXXXX' },
  { code: '+961', country: 'Lebanon', digits: 8, placeholder: '7X XXX XXX' },
  { code: '+266', country: 'Lesotho', digits: 8, placeholder: '5X XXX XXX' },
  { code: '+231', country: 'Liberia', digits: 8, placeholder: '7X XXX XXX' },
  { code: '+218', country: 'Libya', digits: 9, placeholder: '9X XXX XXXX' },
  { code: '+423', country: 'Liechtenstein', digits: 7, placeholder: '6XX XXXX' },
  { code: '+370', country: 'Lithuania', digits: 8, placeholder: '6X XXXXXX' },
  { code: '+352', country: 'Luxembourg', digits: 9, placeholder: '6XX XXX XXX' },
  { code: '+853', country: 'Macau', digits: 8, placeholder: '6XXXXXXX' },
  { code: '+261', country: 'Madagascar', digits: 9, placeholder: '3X XX XXX XX' },
  { code: '+265', country: 'Malawi', digits: 9, placeholder: '99X XXX XXX' },
  { code: '+60', country: 'Malaysia', digits: 9, placeholder: '1X XXX XXXX' },
  { code: '+960', country: 'Maldives', digits: 7, placeholder: '7XX XXXX' },
  { code: '+223', country: 'Mali', digits: 8, placeholder: '7X XX XX XX' },
  { code: '+356', country: 'Malta', digits: 8, placeholder: '7X XXXXXX' },
  { code: '+692', country: 'Marshall Islands', digits: 7, placeholder: '2XX XXXX' },
  { code: '+596', country: 'Martinique', digits: 9, placeholder: '6XX XXX XXX' },
  { code: '+222', country: 'Mauritania', digits: 8, placeholder: '2X XXX XXXX' },
  { code: '+230', country: 'Mauritius', digits: 8, placeholder: '5X XXX XXXX' },
  { code: '+262', country: 'Mayotte', digits: 9, placeholder: '6XX XXX XXX' },
  { code: '+52', country: 'Mexico', digits: 10, placeholder: '22 XXXX XXXX' },
  { code: '+691', country: 'Micronesia', digits: 7, placeholder: '3X XXXX' },
  { code: '+373', country: 'Moldova', digits: 8, placeholder: '6X XXXXXX' },
  { code: '+377', country: 'Monaco', digits: 8, placeholder: '6X XX XX XX' },
  { code: '+976', country: 'Mongolia', digits: 8, placeholder: '5X XXX XXX' },
  { code: '+382', country: 'Montenegro', digits: 8, placeholder: '6X XXXXXX' },
  { code: '+1664', country: 'Montserrat', digits: 10, placeholder: '555 XXX XXXX' },
  { code: '+212', country: 'Morocco', digits: 9, placeholder: '6XX XXX XXX' },
  { code: '+258', country: 'Mozambique', digits: 9, placeholder: '8X XXX XXXX' },
  { code: '+95', country: 'Myanmar', digits: 9, placeholder: '9X XXX XXXX' },
  { code: '+264', country: 'Namibia', digits: 9, placeholder: '81 XXX XXXX' },
  { code: '+977', country: 'Nepal', digits: 10, placeholder: '98X XXX XXXX' },
  { code: '+31', country: 'Netherlands', digits: 9, placeholder: '6 XX XXX XXX' },
  { code: '+687', country: 'New Caledonia', digits: 8, placeholder: '7X XX XX XX' },
  { code: '+64', country: 'New Zealand', digits: 9, placeholder: '2X XXX XXXX' },
  { code: '+505', country: 'Nicaragua', digits: 8, placeholder: '8XXXXXXX' },
  { code: '+227', country: 'Niger', digits: 8, placeholder: '9X XX XX XX' },
  { code: '+234', country: 'Nigeria', digits: 10, placeholder: '80X XXX XXXX' },
  { code: '+683', country: 'Niue', digits: 4, placeholder: 'XXXX' },
  { code: '+850', country: 'North Korea', digits: 10, placeholder: '19X XXX XXXX' },
  { code: '+389', country: 'North Macedonia', digits: 8, placeholder: '7X XXXXXX' },
  { code: '+1670', country: 'Northern Mariana Islands', digits: 10, placeholder: '555 XXX XXXX' },
  { code: '+47', country: 'Norway', digits: 8, placeholder: '4X XX XX XX' },
  { code: '+968', country: 'Oman', digits: 8, placeholder: '9XXXXXXX' },
  { code: '+92', country: 'Pakistan', digits: 10, placeholder: '3XX XXX XXXX' },
  { code: '+680', country: 'Palau', digits: 7, placeholder: '7XX XXXX' },
  { code: '+970', country: 'Palestine', digits: 9, placeholder: '59X XXX XXX' },
  { code: '+507', country: 'Panama', digits: 8, placeholder: '6XXX XXXX' },
  { code: '+675', country: 'Papua New Guinea', digits: 8, placeholder: '7X XXX XXXX' },
  { code: '+595', country: 'Paraguay', digits: 9, placeholder: '9XX XXX XXX' },
  { code: '+51', country: 'Peru', digits: 9, placeholder: '9XX XXX XXX' },
  { code: '+63', country: 'Philippines', digits: 10, placeholder: '9XX XXX XXXX' },
  { code: '+48', country: 'Poland', digits: 9, placeholder: '5X XXX XXXX' },
  { code: '+351', country: 'Portugal', digits: 9, placeholder: '9X XXX XXXX' },
  { code: '+1787', country: 'Puerto Rico', digits: 10, placeholder: '555 XXX XXXX' },
  { code: '+974', country: 'Qatar', digits: 8, placeholder: '5XXXXXXX' },
  { code: '+262', country: 'Reunion', digits: 9, placeholder: '6XX XXX XXX' },
  { code: '+40', country: 'Romania', digits: 9, placeholder: '7X XXX XXXX' },
  { code: '+7', country: 'Russia', digits: 10, placeholder: '9XX XXX XXXX' },
  { code: '+250', country: 'Rwanda', digits: 9, placeholder: '7X XXX XXX' },
  { code: '+1869', country: 'Saint Kitts and Nevis', digits: 10, placeholder: '555 XXX XXXX' },
  { code: '+1758', country: 'Saint Lucia', digits: 10, placeholder: '555 XXX XXXX' },
  { code: '+590', country: 'Saint Martin', digits: 9, placeholder: '6XX XXX XXX' },
  { code: '+508', country: 'Saint Pierre and Miquelon', digits: 6, placeholder: '5XXXXX' },
  { code: '+1784', country: 'Saint Vincent and the Grenadines', digits: 10, placeholder: '555 XXX XXXX' },
  { code: '+685', country: 'Samoa', digits: 7, placeholder: '7X XXXXX' },
  { code: '+378', country: 'San Marino', digits: 8, placeholder: '6XXXXXXX' },
  { code: '+239', country: 'Sao Tome and Principe', digits: 7, placeholder: '9X XXXXX' },
  { code: '+966', country: 'Saudi Arabia', digits: 9, placeholder: '5X XXX XXXX' },
  { code: '+221', country: 'Senegal', digits: 9, placeholder: '7X XXX XXXX' },
  { code: '+381', country: 'Serbia', digits: 9, placeholder: '6X XXX XXXX' },
  { code: '+248', country: 'Seychelles', digits: 7, placeholder: '2X XXXXX' },
  { code: '+232', country: 'Sierra Leone', digits: 8, placeholder: 'XX XXXXXX' },
  { code: '+65', country: 'Singapore', digits: 8, placeholder: '8XXXXXXX' },
  { code: '+421', country: 'Slovakia', digits: 9, placeholder: '9XX XXX XXX' },
  { code: '+386', country: 'Slovenia', digits: 8, placeholder: '3X XXX XXX' },
  { code: '+677', country: 'Solomon Islands', digits: 7, placeholder: '7X XXXXX' },
  { code: '+252', country: 'Somalia', digits: 8, placeholder: '7X XXXXXX' },
  { code: '+27', country: 'South Africa', digits: 9, placeholder: '8X XXX XXXX' },
  { code: '+82', country: 'South Korea', digits: 10, placeholder: '10 XXXX XXXX' },
  { code: '+211', country: 'South Sudan', digits: 9, placeholder: '9X XXX XXXX' },
  { code: '+34', country: 'Spain', digits: 9, placeholder: '6XX XXX XXX' },
  { code: '+94', country: 'Sri Lanka', digits: 9, placeholder: '7X XXX XXXX' },
  { code: '+249', country: 'Sudan', digits: 9, placeholder: '9X XXX XXXX' },
  { code: '+597', country: 'Suriname', digits: 7, placeholder: '2X XXXXX' },
  { code: '+46', country: 'Sweden', digits: 9, placeholder: '7X XXX XXXX' },
  { code: '+41', country: 'Switzerland', digits: 9, placeholder: '7X XXX XXXX' },
  { code: '+963', country: 'Syria', digits: 9, placeholder: '9X XXX XXXX' },
  { code: '+886', country: 'Taiwan', digits: 9, placeholder: '9XX XXX XXX' },
  { code: '+992', country: 'Tajikistan', digits: 9, placeholder: '9X XXX XXXX' },
  { code: '+255', country: 'Tanzania', digits: 9, placeholder: '6X XXX XXXX' },
  { code: '+66', country: 'Thailand', digits: 9, placeholder: '8X XXX XXXX' },
  { code: '+670', country: 'Timor-Leste', digits: 8, placeholder: '7XX XXXX' },
  { code: '+228', country: 'Togo', digits: 8, placeholder: '9X XX XX XX' },
  { code: '+690', country: 'Tokelau', digits: 4, placeholder: 'XXXX' },
  { code: '+676', country: 'Tonga', digits: 5, placeholder: 'XXXXX' },
  { code: '+1868', country: 'Trinidad and Tobago', digits: 10, placeholder: '555 XXX XXXX' },
  { code: '+216', country: 'Tunisia', digits: 8, placeholder: '2X XXX XXX' },
  { code: '+90', country: 'Turkey', digits: 10, placeholder: '5XX XXX XXXX' },
  { code: '+993', country: 'Turkmenistan', digits: 8, placeholder: '6X XXXXXX' },
  { code: '+1649', country: 'Turks and Caicos Islands', digits: 10, placeholder: '555 XXX XXXX' },
  { code: '+688', country: 'Tuvalu', digits: 5, placeholder: 'XXXXX' },
  { code: '+256', country: 'Uganda', digits: 9, placeholder: '7XX XXX XXX' },
  { code: '+380', country: 'Ukraine', digits: 9, placeholder: '50 XXX XXXX' },
  { code: '+971', country: 'United Arab Emirates', digits: 9, placeholder: '5X XXX XXXX' },
  { code: '+44', country: 'United Kingdom', digits: 10, placeholder: '7XXX XXXXXX' },
  { code: '+1', country: 'United States', digits: 10, placeholder: '555 XXX XXXX' },
  { code: '+598', country: 'Uruguay', digits: 8, placeholder: '9X XXXXXX' },
  { code: '+998', country: 'Uzbekistan', digits: 9, placeholder: '9X XXX XXXX' },
  { code: '+678', country: 'Vanuatu', digits: 7, placeholder: '5X XXXXX' },
  { code: '+58', country: 'Venezuela', digits: 10, placeholder: '4XX XXX XXXX' },
  { code: '+84', country: 'Vietnam', digits: 9, placeholder: '9X XXX XXXX' },
  { code: '+1284', country: 'Virgin Islands (US)', digits: 10, placeholder: '555 XXX XXXX' },
  { code: '+681', country: 'Wallis and Futuna', digits: 6, placeholder: 'XX XXXX' },
  { code: '+967', country: 'Yemen', digits: 9, placeholder: '7XX XXX XXXX' },
  { code: '+260', country: 'Zambia', digits: 9, placeholder: '9X XXX XXXX' },
  { code: '+263', country: 'Zimbabwe', digits: 9, placeholder: '7X XXX XXXX' },
];
